<template>
    <div>
        <select 
                name="year" 
                id="year" 
                class="py-2 pl-3 pr-10 mt-1 mb-4 text-base border-gray-300 rounded-md focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                @change="updateYear"
            >
                <option value=2017>2017</option>
                <option value=2018>2018</option>
                <option value=2019>2019</option>
                <option value=2020>2020</option>
                <option value=2021>2021</option>
                <option value=2022>2022</option>
                <option value=2023 selected>2023</option>
            </select>
        <div v-if="isLoading" class="w-10 h-10 mt-20 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
        <div v-else class="md:-mx-6 lg:-mx-8">
            
            <div class="inline-block min-w-full align-middle md:px-6 lg:px-8">
                <div class="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
                    <table class="min-w-full divide-y divide-gray-200 tw-table">
                    <thead class="bg-gray-50">
                        <tr>
                            <th scope="col"
                                class="w-1/3 px-3 py-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                CPT Code
                            </th>
                            <th scope="col"
                                class="w-1/5 px-3 py-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                Description
                            </th>
                            <th scope="col"
                                class="px-3 py-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase align-bottom md:px-6 md:py-2 w-1/7">
                                Source
                            </th>
                            <th scope="col"
                                class="w-1/6 px-3 py-1 text-xs font-medium tracking-wider text-right text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                Avg Charge
                            </th>
                            <th scope="col"
                                class="w-1/6 px-3 py-1 text-xs font-medium tracking-wider text-right text-gray-500 uppercase align-bottom md:px-6 md:py-2"
                            >
                                Services
                            </th>
                            <th scope="col"
                                class="w-1/3 px-3 py-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase align-bottom md:px-6 md:py-2">
                                Year
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(procedure, index) in this.searchResults"
                            :key="index"
                            :class="{
                                'bg-gray-100':index % 2 == 0
                            }
                            "
                        >
                            <td class="w-1/5 px-3 py-1 text-xs font-medium text-gray-500 align-middle md:text-sm md:px-6 md:py-2">
                                {{ procedure.HCPCS_Cd }}
                            </td>
                            <td class="w-1/2 px-3 py-1 text-xs text-gray-900 align-middle md:text-sm md:px-6 md:py-2">
                                {{procedure.HCPCS_Desc}}
                            </td>
                            <td class="w-1/5 px-3 py-1 text-xs text-gray-500 align-middle md:text-sm md:px-6 md:py-2">
                                <span
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 bg-blue-100 text-blue-800">
                                    CMS
                                </span>
                            </td>
                            <td class="w-1/6 px-3 py-1 text-xs font-medium text-right text-green-500 align-middle md:text-sm md:px-6 md:py-2">
                                {{ formatMoney(procedure.Avg_Mdcr_Pymt_Amt) }}
                            </td>
                            <td class="w-1/6 px-3 py-1 text-xs font-medium text-right align-middle md:text-sm md:px-6 md:py-2">
                                {{ procedure.Tot_Srvcs }}
                            </td>
                            <td class="w-1/5 px-3 py-1 text-xs text-gray-500 align-middle md:text-sm md:px-6 md:py-2">
                                {{ procedure.year }}
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        searchRoute: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            searchResults: {},
            isLoading: false,
            serverParams: {
                year: 2023
            },
        }
    },
    created() {
        this.loadItems();
    },
    methods: {
        async loadItems() {
            try {
                this.isLoading = true;
                const response = await axios.get(this.searchRoute, { params: this.serverParams });
                this.searchResults = response.data;
                this.isLoading = false;
            } catch (error) {
                this.rows = []

                this.isLoading = false;
            }
            
            return true;
        },
        formatMoney(money){
            let dollarUSLocale = Intl.NumberFormat('en-US', {
                style: "currency",
                currency: "USD"
            });
            return dollarUSLocale.format(money);
        },
        updateYear: function(e){
            var val = e.target.value;
            this.serverParams.year = val;
            this.loadItems();
        }
    }
}
</script>
